import React, {useEffect, useRef, useState} from "react";
import styles from "./Accordion.module.css";
import * as DOMPurify from "dompurify";

const Accordion = (props: {
  defaultOpen?: boolean,
  openIndex?: number,
  items: {
    title: string,
    htmlContent: string,
  }[],
  lightTheme?: boolean,
}) => {
  const [openIndex, setOpenIndex] = useState(props.defaultOpen === true ? 0 : null);
  const {defaultOpen, openIndex: openIndexProps, items} = props;
  const itemsJson = JSON.stringify(items);
  const openTitleRef = useRef<HTMLHeadingElement>(null);

  // Set new openIndex when the prop value changes
  useEffect(() => {
    if (openIndexProps !== undefined && openIndexProps >= 0) {
      setOpenIndex(openIndexProps);
    }
  }, [openIndexProps]);

  // Scroll to open accordion when it changes
  useEffect(() => {
    // Wait for correct rendering
    setTimeout(() => {
      if (openTitleRef.current !== null)
        window.scrollTo({top: openTitleRef.current.getBoundingClientRect().top + window.scrollY - 16, behavior: 'smooth'});
    }, 75);
  }, [openIndex]);

  // Reset to default open state when items change
  useEffect(() => setOpenIndex(defaultOpen === true ? 0 : null), [itemsJson, defaultOpen]);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  }

  return <>
    {props.items.map((item, i) =>
      <div key={i} className={styles.container}>
        <div className={`${styles.title} ${props.lightTheme ? styles.light : ''}`} onClick={() => toggle(i)}>
          <h4 ref={openIndex === i ? openTitleRef : undefined}><span className={`${styles.arrow} ${openIndex === i ? '' : styles.hidden}`}>&#9660;</span> {item.title}</h4>
        </div>
        <div className={`${styles.content} ${openIndex === i ? '' : styles.hidden}`} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.htmlContent, { ADD_ATTR: ['target'] })}}/>
      </div>
    )}
  </>;
}


export default Accordion;
